"use strict";
module.exports = require('./en');



//////////////////
// WEBPACK FOOTER
// ./~/date-names/index.js
// module id = 1050
// module chunks = 1